import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, LogoutOutlinedIcon, Typography } from '@/shared/ui/mui';
import useAuth from '@/features/auth/hooks/useAuth';

export interface LogoutButtonProps {
  onClose: () => void;
}

const LogoutButton: FC<LogoutButtonProps> = ({ onClose }) => {
  const { logout } = useAuth();
  const { t } = useTranslation('navigation');

  const handleLogout = () => {
    // Use our centralized logout method
    logout();
    onClose();
  };

  return (
    <Button
      onClick={handleLogout}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        py: 1.5,
        px: 3,
        width: '100%',
        color: 'text.secondary',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <LogoutOutlinedIcon
        sx={{
          mr: 2,
          color: 'primary.main',
        }}
      />
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
        }}
      >
        {t('menu.logout', { defaultValue: 'Logout' })}
      </Typography>
    </Button>
  );
};

export default LogoutButton;
